module.exports = __webpack_public_path__ + "static/media/TotalBatches.230d1b2c.svg";